module.exports = __webpack_public_path__ + "img/icon-game-help.15406967.svg";